/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { clearAllLocalStorageData } from "utils/LocalStorage";
import useAssociateCampaignAsset from "./useAssociateCampaignAsset";
import useCreateAssetFromStorage from "./useCreateAssetFromStorage";
import useCreateCampaign from "./useCreateCampaign";
import useFindOrCreateUser from "./useFindOrCreateUser";

const useOnboardUser = () => {
  const [mappedFormData, setMappedFormData] = useState([]);
  const [coverImageId, setCoverImageId] = useState();
  const [userData, setUserData] = useState({});
  const [errors, setErrors] = useState();
  const [onBoardLoading, setOnboardLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [creatingAsset, setCreatingAsset] = useState(false);
  const [creatingCampaign, setCreatingCampaign] = useState(false);
  const [campaignCreated, setCampaignCreated] = useState(false);
  const [associatingAsset, setAssociatingAsset] = useState(false);

  const onBoardUser = (onBoardData) => {
    const tempFormData = onBoardData.mappedFormData;
    tempFormData.target.currency = "aud";
    tempFormData.target.amount *= 100;
    setMappedFormData(tempFormData);
    setUserData(onBoardData?.userData);
  };

  const isValidId = (id) => {
    if (!id) {
      return false;
    }

    if (isNaN(Number(id))) {
      return id.length > 0;
    }

    return id > 0;
  };

  const {
    findOrCreateUser,
    userLoggedIn: findUserLoggedIn,
    errors: createUserErrors,
  } = useFindOrCreateUser();

  const {
    associateCampaignAsset,
    data: associateData,
    error: associateAssetError,
  } = useAssociateCampaignAsset();

  const {
    createAssetFromStorage,
    assetId,
    error: assetCreateErrors,
  } = useCreateAssetFromStorage();

  const {
    createCampaign,
    campaignId,
    error: createCampaignErrors,
  } = useCreateCampaign();

  useEffect(() => {
    if (isValidId(assetId)) {
      setCoverImageId(assetId);
    }
  }, [assetId]);

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      findOrCreateUser(userData);
    }
  }, [userData]);

  useEffect(() => {
    if (isValidId(campaignId)) {
      setCampaignCreated(true);
    }
  }, [campaignId]);

  useEffect(async () => {
    if (findUserLoggedIn) {
      if (!creatingAsset && !coverImageId) {
        createAssetFromStorage("onBoarding", "coverImage");
        setCreatingAsset(true);
      }
      if (!creatingCampaign && !campaignId && coverImageId) {
        setCreatingCampaign(true);
        createCampaign(mappedFormData);
      }
    }
  }, [
    findUserLoggedIn,
    mappedFormData,
    createCampaign,
    creatingCampaign,
    coverImageId,
    creatingAsset,
  ]);

  useEffect(() => {
    if (campaignCreated && coverImageId) {
      if (!associatingAsset) {
        clearAllLocalStorageData();
        associateCampaignAsset(coverImageId, campaignId);
        setAssociatingAsset(true);
      }
    }
  }, [campaignId, coverImageId, campaignCreated, associatingAsset]);

  useEffect(() => {
    if (associateData?.associateCampaignAsset?.asset?.id) {
      setOnboardLoading(false);
      setSuccess(true);
      clearAllLocalStorageData();
    }
  }, [associateData]);

  useEffect(() => {
    if (createUserErrors) {
      setErrors("There was an error creating the user");
    }

    if (assetCreateErrors || associateAssetError) {
      setCreatingAsset(false);
      setErrors("We couldn't process that image, please try another or make the crop smaller.");
    }
  }, [createCampaignErrors, assetCreateErrors, createUserErrors, associateAssetError]);

  return {
    onBoardUser: (onBoardData, assetId) => {
      setOnboardLoading(true);
      onBoardUser(onBoardData, assetId);
    },
    onBoardLoading,
    campaignId,
    success,
    errors,
  };
};

export default useOnboardUser;
